import { useQuery } from '@tanstack/react-query';

import { getGivingHistory } from '@sola/proxy-sdk/utils/routes.ts';
import { GiftFundCodesEnum } from '@sola/schema/dotcom/shared/gifts.ts';

import { QUERY_KEYS } from '../constants.ts';
import { useReadyForQueries } from './base.ts';

/**
 * Hook to fetch giving history.
 *
 * TODO Mocks
 */
type UseGivingHistoryParams = {
  start: string;
  end: string;
  beneficiaryGlobalId?: string;
  fundCodes?: GiftFundCodesEnum[];
  enabled?: boolean;
};

export const useGivingHistory = ({
  start,
  end,
  beneficiaryGlobalId,
  fundCodes,
  enabled = true,
}: UseGivingHistoryParams) => {
  const { isReady, globalId } = useReadyForQueries();
  const fundCodesParam = fundCodes?.join(',');

  return useQuery({
    queryKey: [
      QUERY_KEYS.supporterGivingHistory,
      globalId,
      start,
      end,
      beneficiaryGlobalId,
      fundCodesParam,
    ],
    queryFn: () =>
      getGivingHistory(globalId!, {
        start,
        end,
        beneficiaryglobalids: beneficiaryGlobalId,
        fundcodes: fundCodesParam,
      }),
    refetchOnWindowFocus: false,
    enabled: isReady && enabled,
    staleTime: Infinity,
  });
};
